export function mergeId<Id extends string | number>(prevId: Id | null, nextId: Id | null, nextIds: Id[]): Id | null {
  if (prevId && nextIds.includes(prevId)) {
    return prevId;
  }

  if (nextId && nextIds.includes(nextId)) {
    return nextId;
  }

  return null;
}
